import { getCareplanUnitPricing } from "@/domains/careplan/factories/create-careplan-order-model";
import type { DraftCartItem, SubscriptionProductDataModel } from "@/domains/careplan/models/types";
import type { CareplanCartItem } from "@/stores";

type BuildDraftCartItemsInput = {
  cartItems: CareplanCartItem[];
  subscriptionProducts: SubscriptionProductDataModel[];
  recommendedCartLines: CareplanCartItem[] | null;
};

export const buildDraftCartItems = ({
  cartItems,
  recommendedCartLines,
  subscriptionProducts,
}: BuildDraftCartItemsInput): DraftCartItem[] => {
  const subscriptionVariantIds = new Set(
    subscriptionProducts.map((product) => {
      return product.variantId;
    }),
  );

  return [
    ...subscriptionProducts.map((item) => {
      return {
        ...item,
        source: "subscription" as const,
      };
    }),
    ...(recommendedCartLines ?? [])
      .filter((item) => {
        return item.variantId === undefined || !subscriptionVariantIds.has(item.variantId);
      })
      .map((item) => {
        const currentCartLineItem = cartItems.find((currentItem) => {
          return currentItem.variantId === item.variantId;
        });

        return {
          ...item,
          ...getCareplanUnitPricing(currentCartLineItem ?? item),
          id: currentCartLineItem?.id ?? item.id,
          image: currentCartLineItem?.image ?? item.image,
          quantity: currentCartLineItem?.quantity ?? 0,
          isActive: !!currentCartLineItem,
          source: "recommended" as const,
        };
      }),
  ];
};

export const areAllDraftItemsInactive = (items: DraftCartItem[]) => {
  return items.every((item) => {
    return !item.isActive;
  });
};
